module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAMFBMVEUAAADR09TR09TR09SAgoWAgoWAgoWNj5GAgoXR09SNj5HdLkSAgoXm5+hVrO47iMMisfmGAAAACXRSTlMAUN8AUN8AABAgWm2rAAAAsUlEQVR42u3T0Q7CIAxA0bbAtFvV//9b3Ys1HQSIGBPW87asuSGEQhESHxCGEggFyFnYHdLzbC96pu4Q50PsoR+FNsND/o7mCKm/hmKSqhQXCxYjSpNYDa3SZL0YYL6v0uh4InMnt0b2ziCK6g6pCGlMKIGMCQmwsQ/dK/YZNmYPmaFqyM6cL1R3spDvmu+a75rvmu+a79rcu/b2yNC//MFDjSEaEyLAMSGEgPR9iDA8AZMFzo6KnJZxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3e5.png
// module id = 813
// module chunks = 0